import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import "./pageHeader.scss";
import HeaderBgImg from "../images/bg1.jpg";
import { motion } from "framer-motion";
import { ParallaxBanner } from "react-scroll-parallax";

const titleVariants = {
  hidden: { opacity: 0, y: -100 },
  visible: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -100 },
};

const PageHeader = ({ title, backgroundImage, opacity }) => {
  return (
    <>
      <ParallaxBanner
        layers={[{ image: backgroundImage, speed: -20 }]}
        className="page-header"
      >
        <div className="max-w-container mx-auto px-4 pt-24">
          <div className="text-center text-white">
            <motion.h1
              variants={titleVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
              transition={{ type: "spring", duration: 1 }}
              className="text-100 font-medium"
            >
              {title}.
            </motion.h1>
            <motion.div
              className=""
              variants={titleVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
              transition={{ type: "spring", duration: 1.2 }}
            >
              <Link to="/" className="text-white hover:underline">
                Home
              </Link>
              <span className="mx-5">|</span>
              <span className="text-primary">{title}</span>
            </motion.div>
          </div>
        </div>
        <div className="page_header_overlay" style={{ opacity }} ></div>
      </ParallaxBanner>
    </>
  );
};

PageHeader.propTypes = {
  title: PropTypes.string,
  backgroundImage: PropTypes.string,
  opacity: PropTypes.string,
};

PageHeader.defaultProps = {
  backgroundImage: HeaderBgImg,
  opacity: "0.8",
  title: "Page Title",
};

export default PageHeader;
